import TagType from '@jbhi-fi/lanyard-ui/components/Tag/types/tag.type';

const TAG_TYPES = {
  Cheapest: { type: 'yellow' as TagType, content: 'CHEAPEST' },
  Fastest: { type: 'error' as TagType, content: 'FASTEST' },
  'Cheap and Fast': { type: 'yellow' as TagType, content: 'CHEAP + FAST' },
};

export const parseDeliveryTags = (tags: Array<string>, isFree: boolean): Array<{ type: TagType; content: string }> => {
  if (isFree) {
    return [{ type: 'success' as TagType, content: 'FREE' }];
  }

  const outputTags = [];
  tags.forEach(tag => {
    const outputTag = TAG_TYPES[tag];
    if (outputTag) {
      outputTags.push(outputTag);
    }
  });
  return outputTags;
};
